import { EnvironmentConfig, ProjectConfig } from './environment.interface';

const sandbox: EnvironmentConfig = {
  production: false,
  envName: 'sandbox',
  apiBookingServiceUrl: 'https://sandbox-api.poshvine.com/bs/v1',
  apiClientsServiceUrl: 'https://sandbox-api.poshvine.com/cs/v1',
  apiPerksServiceUrl: 'https://sandbox-api.poshvine.com/ps/v1',
  apiUrlPaV1: 'https://sandbox-api.poshvine.com/pa/v1/',
};

const production: EnvironmentConfig = {
  production: true,
  envName: 'production',
  apiBookingServiceUrl: 'https://api-customer.poshvine.com/bs/v1',
  apiClientsServiceUrl: 'https://api-customer.poshvine.com/cs/v1',
  apiPerksServiceUrl: 'https://api-customer.poshvine.com/ps/v1',
  apiUrlPaV1: 'https://api-customer.poshvine.com/pa/v1/',
};

const visaGcc: ProjectConfig = {
  projectName: 'visaGcc',
  projectTitle: 'Visa GCC Benefits',
  gTagTrackingId: 'G-DQTFP01VTP',
  sentryDsn:
    'https://06e43ed670c486f933118ce1dbe334ad@o515678.ingest.us.sentry.io/4507288014487552',
  showLanguageDropdown: false,
  airportTransferFlag: true,
  showAirportTransferByDefault: false,
  isAirportTransferVisible: true,
  offerListingFlag: true,
  offerSearchFlag: true,
  orderHistoryFlag: true,
  benefitsCategoryTabFlag: true,
  redeemTabFlag: true,
  otpTooltipFlag: false,
  recaptchaFlag: true,
  razorAnalyticsFlag: false,
  headerComponent: {
    customerSupportIconUrl:
      'https://assets.poshvine.com/merchants/visa/ssa/icons/question-mark-icon-blue.webp',
  },
  preLoginPage: {
    header: {
      imageUrl:
        'https://images.poshvine.com/visa-gcc/visa-gcc-prelogin-banner-image.webp',
      imageAltText: 'person holding a camera',
    },
    programBenefits: {
      offers: {
        imageUrl:
          'https://images.poshvine.com/visa-gcc/visa-gcc-save-image.webp',
        imageAltText: 'person near lanterns',
        linkUrl: 'offers',
        reverse: true,
        authenticationRequired: false,
      },
      airportTransfer: {
        imageUrl:
          'https://images.poshvine.com/visa-gcc/visa-gcc-upgrade-image.webp',
        imageAltText: 'person near cabs',
        linkUrl: 'airport-cab-booking',
        reverse: false,
        authenticationRequired: true,
      },
    },
  },
  offerListingPage: {
    offerChips: true,
    showCategoryChips: true,
  },
  orderHistoryPage: {
    showPrice: true,
  },
  footerComponent: {
    emailId: 'visagcc-support@razorpay.com',
    faqLink: '',
    privacyPolicyLink: '/info/privacy-policy',
    termsAndConditionsLink: '/info/terms-and-conditions',
    bannerImages: {
      mobile: {
        url: 'https://images.poshvine.com/visa-gcc/footer-image-mobile.webp',

        altText: 'visa gcc footer mobile',
      },
      desktop: {
        url: 'https://images.poshvine.com/visa-gcc/footer-image-desktop.webp',

        altText: 'visa gcc footer desktop',
      },
    },
    razorpayLogo: {
      url: 'https://assets.poshvine.com/merchants/razorpay/common/icons/icon-light.svg',
    },
    textColor: '#000000',
  },
  loginModal: {
    showLoginCheckboxes: true,
  },
  cardSelectionDropdown: {
    disableForSingleCard: true,
  },
  bannerConfig: {
    bannerCards: [
      {
        type: 'regular',
        cta: 'Book Airport Transfer',
        imageSrc:
          'https://images.poshvine.com/visa-gcc/postlogin-banner-card-airport.webp',
        imageAltText: 'people entering cab',
        ctaLink: 'airport-cab-booking',
        visibleIf: 'isAirportTransferAvailable',
      },
      {
        type: 'regular',
        cta: 'Explore Exclusive Offers',
        imageSrc:
          'https://images.poshvine.com/visa-gcc/postlogin-banner-card-offers.webp',
        imageAltText: 'people laughing',
        ctaLink: 'offers',
        visibleIf: 'always',
      },
    ],
  },
};

const visaHajj: ProjectConfig = {
  projectName: 'visaHajj',
  projectTitle: 'Visa Hajj',
  gTagTrackingId: '',
  sentryDsn: '',
  populatePvCurrentState: true,
  showBookNowCategory: true,
  showLanguageDropdown: false,
  airportTransferFlag: true,
  showAirportTransferByDefault: true,
  isAirportTransferVisible: true,
  offerListingFlag: false,
  offerSearchFlag: true,
  orderHistoryFlag: true,
  benefitsCategoryTabFlag: true,
  redeemTabFlag: true,
  otpTooltipFlag: false,
  recaptchaFlag: false,
  razorAnalyticsFlag: false,
  headerComponent: {
    customerSupportIconUrl:
      'https://assets.poshvine.com/merchants/visa/ssa/icons/question-mark-icon-blue.webp',
  },
  airportTransferLimits: {
    maxPassengers: 8,
    maxLuggage: 8,
  },
  loginModal: {
    showLoginCheckboxes: true,
  },
  preLoginPage: {
    header: {
      imageUrl:
        'https://assets.poshvine.com/merchants/visa/hajj/images/prelogin-header.webp',
      imageAltText: 'person holding a camera',
    },
    programBenefits: {
      airportTransfer: {
        imageUrl:
          'https://assets.poshvine.com/merchants/visa/hajj/images/prelogin-airport-transfer-card-image.webp',
        imageAltText: 'person near cabs',
        linkUrl: 'airport-cab-booking',
        reverse: false,
        authenticationRequired: true,
      },
      offers: {
        imageUrl:
          'https://assets.poshvine.com/merchants/visa/hajj/images/prelogin-offers-card-image.webp',
        imageAltText: 'person near lanterns',
        linkUrl: 'offers',
        reverse: true,
        authenticationRequired: false,
      },
    },
  },
  offerListingPage: {
    offerChips: true,
    showCategoryChips: true,
    showPaymentOffers: false,
  },
  orderHistoryPage: {
    showPrice: true,
  },
  footerComponent: {
    emailId: 'support-poshvine@razorpay.com',
    faqLink: '',
    privacyPolicyLink: '/info/privacy-policy',
    termsAndConditionsLink: '/info/terms-and-conditions',
    bannerImages: {
      mobile: {
        url: 'https://assets.poshvine.com/merchants/visa/ssa/images/footer-mobile-2.svg',
        altText: 'visa ssa footer mobile',
      },
      desktop: {
        url: 'https://assets.poshvine.com/merchants/visa/ssa/images/footer-desktop-2.svg',
        altText: 'visa ssa footer desktop',
      },
    },
    textColor: '#000000',
    razorpayLogo: {
      url: 'https://assets.poshvine.com/merchants/razorpay/common/icons/icon-light.svg',
      style: {
        width: '100px',
      },
    },
    style: {
      position: 'relative',
      'background-color': '#ffffff',
    },
  },
  cardSelectionDropdown: {
    disableForSingleCard: true,
  },
  bannerConfig: {
    bannerCards: [
      {
        type: 'regular',
        cta: 'Book Umrah',
        imageSrc:
          'https://assets.poshvine.com/merchants/visa/hajj/images/postlogin-umrah-card-image.webp',
        imageAltText: 'Umrah',
        ctaLink: 'offers',
        visibleIf: 'always',
      },
      {
        type: 'comingSoon',
        title: 'Book Hajj',
        subtitle: 'COMING SOON',
        imageSrc:
          'https://assets.poshvine.com/merchants/visa/hajj/images/postlogin-hajj-card-image.webp',
        imageAltText: 'Kaaba with pilgrims',
        visibleIf: 'always',
      },
    ],
  },
};

const visaSsa: ProjectConfig = {
  projectName: 'visaSsa',
  projectTitle: 'Visa SSA Benefits',
  gTagTrackingId: 'G-XY7R0PR3XZ',
  sentryDsn:
    'https://e27e7f9836f2119697e93ad688278626@o515678.ingest.us.sentry.io/4509438681022464',
  showRedemptionModalOnBooking: true,
  useCustomSignupErrorMessage: true,
  needPersonalisedParam: true,
  showLanguageDropdown: true,
  airportTransferFlag: false,
  showAirportTransferByDefault: false,
  isAirportTransferVisible: false,
  offerListingFlag: true,
  offerSearchFlag: true,
  orderHistoryFlag: true,
  benefitsCategoryTabFlag: true,
  otpTooltipFlag: true,
  redeemTabFlag: true,
  recaptchaFlag: false,
  razorAnalyticsFlag: true,
  headerComponent: {
    customerSupportIconUrl:
      'https://assets.poshvine.com/merchants/visa/ssa/icons/customer-support-blue.svg',
  },
  preLoginPage: {
    header: {
      imageUrl:
        'https://assets.poshvine.com/merchants/visa/ssa/images/man-looking-tab.avif',
      imageAltText: 'person holding a mobile phone',
    },
    programBenefits: {
      offers: {
        imageUrl:
          'https://assets.poshvine.com/merchants/visa/ssa/images/restaurant-with-low-light.avif',
        imageAltText: 'restaurant with low light',
        linkUrl: 'offers',
        reverse: true,
        authenticationRequired: false,
      },
    },
  },
  offerListingPage: {
    offerChips: true,
    showCategoryChips: true,
    showPaymentOffers: true,
  },
  orderHistoryPage: {
    showPrice: true,
  },
  footerComponent: {
    emailId: 'ssasupport@razorpay.africa',
    faqLink: 'https://images.poshvine.com/visa-ssa/visa-ssa-FAQs-06102025.pdf',
    privacyPolicyLink: '/info/privacy-policy',
    termsAndConditionsLink: '/info/terms-and-conditions',
    bannerImages: {
      mobile: {
        url: 'https://assets.poshvine.com/merchants/visa/ssa/images/footer-mobile-2.webp',
        altText: 'visa ssa footer mobile',
      },
      desktop: {
        url: 'https://assets.poshvine.com/merchants/visa/ssa/images/footer-desktop-2.svg',
        altText: 'visa ssa footer desktop',
      },
    },
    textColor: '#000000',
    razorpayLogo: {
      url: 'https://assets.poshvine.com/merchants/razorpay/common/icons/icon-light.svg',
      style: {
        width: '100px',
      },
    },
    style: {
      'padding-bottom': '2rem',
    },
  },
  loginModal: {
    faqLine: true,
    showLoginCheckboxes: false,
  },
  cardSelectionDropdown: {
    disableForSingleCard: false,
  },
  bannerConfig: {
    bannerCards: [
      {
        type: 'regular',
        cta: 'Explore Exclusive Offers',
        imageSrc:
          'https://images.poshvine.com/visa-gcc/postlogin-banner-card-offers.webp',
        imageAltText: 'people laughing',
        ctaLink: 'offers',
        visibleIf: 'always',
      },
    ],
  },
};

const visaForex: ProjectConfig = {
  projectName: 'visaForex',
  projectTitle: 'Visa Forex',
  gTagTrackingId: 'G-V9L45JNC9E',
  sentryDsn:
    'https://9cfbb25a28812d23e5e5bbffd4649b87@o515678.ingest.us.sentry.io/4509171994001408',
  needPersonalisedParam: true,
  showForexTnCLink: true,
  showLanguageDropdown: false,
  airportTransferFlag: false,
  showAirportTransferByDefault: false,
  isAirportTransferVisible: false,
  offerListingFlag: true,
  offerSearchFlag: false,
  orderHistoryFlag: false,
  benefitsCategoryTabFlag: false,
  otpTooltipFlag: false,
  redeemTabFlag: true,
  recaptchaFlag: false,
  razorAnalyticsFlag: false,
  headerComponent: {
    customerSupportIconUrl:
      'https://assets.poshvine.com/merchants/visa/ssa/icons/question-mark-icon-blue.webp',
  },
  preLoginPage: {
    header: {
      imageUrl:
        'https://assets.poshvine.com/merchants/visa/forex/images/woman-at-airport.avif',
      imageAltText: 'man walking with shopping bags',
    },
    programBenefits: {
      offers: {
        authenticationRequired: false,
        imageAltText: '',
        imageUrl: '',
        linkUrl: '',
        reverse: false,
      },
    },
  },
  offerListingPage: {
    offerChips: true,
    showCategoryChips: false,
  },
  orderHistoryPage: {
    showPrice: false,
  },
  footerComponent: {
    emailId: 'visaprepaid-support@razorpay.com',
    faqLink: 'https://www.tsim.mobi/esim-faq',
    privacyPolicyLink: '/info/privacy-policy',
    termsAndConditionsLink: '/info/terms-and-conditions',
    bannerImages: {
      mobile: {
        url: 'https://images.poshvine.com/visa-gcc/footer-image-mobile.webp',
        altText: 'visa forex footer mobile',
      },
      desktop: {
        url: 'https://images.poshvine.com/visa-gcc/footer-image-desktop.webp',
        altText: 'visa forex footer desktop',
      },
    },
    razorpayLogo: {
      url: 'https://assets.poshvine.com/merchants/razorpay/common/icons/icon-light.svg',
    },
    textColor: '#000000',
  },
  loginModal: {
    showLoginCheckboxes: true,
  },
  cardSelectionDropdown: {
    disableForSingleCard: true,
  },
  bannerConfig: {
    bannerCards: [
      {
        type: 'regular',
        cta: 'Explore Offers',
        imageSrc:
          'https://images.poshvine.com/visa-gcc/postlogin-banner-card-offers.webp',
        imageAltText: 'people laughing',
        ctaLink: 'offers',
        visibleIf: 'always',
      },
    ],
  },
};

const visaCambodia: ProjectConfig = {
  projectName: 'visaCambodia',
  projectTitle: 'Visa Cambodia Benefits',
  gTagTrackingId: 'G-XXXXXXXXXX',
  sentryDsn: 'https://placeholder@o515678.ingest.us.sentry.io/0000000000000000',
  showLanguageDropdown: false,
  airportTransferFlag: false,
  showAirportTransferByDefault: false,
  isAirportTransferVisible: false,
  offerListingFlag: false,
  offerSearchFlag: false,
  orderHistoryFlag: false,
  benefitsCategoryTabFlag: false,
  otpTooltipFlag: false,
  redeemTabFlag: false,
  recaptchaFlag: false,
  razorAnalyticsFlag: false,
  tierGamificationFlag: true,
  rewardClaimFlag: true,
  rewardHistoryFlag: true,
  headerComponent: {
    customerSupportIconUrl:
      'https://assets.poshvine.com/merchants/visa/ssa/icons/question-mark-icon-blue.webp',
  },
  preLoginPage: {
    header: {
      imageUrl:
        'https://assets.poshvine.com/merchants/visa/cambodia/images/header-image.avif',
      imageAltText: 'person holding a mobile phone',
    },
    programBenefits: {
      offers: {
        imageUrl:
          'https://assets.poshvine.com/merchants/visa/cambodia/images/benefits.avif',
        imageAltText: 'visa cambodia benefits',
        linkUrl: 'rewards',
        reverse: true,
        authenticationRequired: false,
      },
    },
  },
  offerListingPage: {
    offerChips: false,
    showCategoryChips: false,
    showPaymentOffers: false,
  },
  orderHistoryPage: {
    showPrice: false,
  },
  footerComponent: {
    emailId: 'support-poshvine@razorpay.com',
    faqLink: 'https://images.poshvine.com/visa-cambodia/visa-cambodia-FAQs.pdf',
    privacyPolicyLink: '/info/privacy-policy',
    termsAndConditionsLink: '/info/terms-and-conditions',
    bannerImages: {
      mobile: {
        url: 'https://assets.poshvine.com/merchants/visa/cambodia/images/footer-mobile.webp',
        altText: 'visa cambodia footer mobile',
      },
      desktop: {
        url: 'https://assets.poshvine.com/merchants/visa/cambodia/images/footer-desktop.svg',
        altText: 'visa cambodia footer desktop',
      },
    },
    textColor: '#000000',
    razorpayLogo: {
      url: 'https://assets.poshvine.com/merchants/razorpay/common/icons/icon-light.svg',
      style: {
        width: '100px',
      },
    },
    style: {
      'padding-bottom': '2rem',
    },
  },
  loginModal: {
    faqLine: true,
    showLoginCheckboxes: true,
  },
  cardSelectionDropdown: {
    disableForSingleCard: true,
  },
  bannerConfig: {
    bannerCards: [],
  },
};

export const commonEnvObject = {
  sandbox,
  production,
  visaGcc,
  visaHajj,
  visaSsa,
  visaForex,
  visaCambodia,
};
